import React from 'react';
import { buyMeCoffeeUrl } from '../utils/podcastInfo';
import '../styles/about.css';

// Host data in multiline strings for easy editing
const jesseBio = `Jesse is a Staff Platform Engineer at Dotmatics with extensive experience in Kubernetes, cloud architecture, and DevOps practices. With a proven track record at companies like Chewy, MassMutual, and Ingenico Mobile Solutions, Jesse has led teams in transforming containerized tech stacks, implementing CI/CD pipelines, and architecting next-generation cloud solutions that significantly improve development velocity and operational efficiency.

Jesse specializes in building auto-healing systems using Kubernetes, Golang, and GitOps methodologies. His expertise in mentoring teams has consistently resulted in lower failure rates, improved MTTR, and higher uptime across enterprise systems.`;

const jesseImage = "/images/jesse.jpeg";
const jesseLinkedIn = "https://linkedin.com/in/jesse-cafarelli";
const jesseTwitter = "";
const jesseGitHub = "https://github.com/derage";

const joshBio = `Josh is a Senior Software Engineer who got his start at the robotics startup Alert Innovation, specializing in enhancing embedded technologies with modern DevOps practices. He brings practical insights on automation, monitoring, and scalability that benefit organizations of all sizes.

A world traveler who has lived in multiple countries, Josh brings a unique global perspective to technology discussions. His experience navigating diverse cultural environments has enhanced his ability to solve problems creatively and collaborate across teams.

With his unconventional background, Josh approaches technical challenges with fresh perspectives that make container technologies accessible to listeners of all experience levels. His focus on practical solutions consistently improves developer productivity and system reliability.`;

const joshImage = "/images/josh.jpeg";
const joshLinkedIn = "https://www.linkedin.com/in/joshua-warhurst-a099b1210/";
const joshTwitter = "";
const joshGitHub = "";

// Podcast description in multiline string
const podcastDescription = `Welcome to Containerized Conversations, where we explore the world of containers, Kubernetes, and cloud-native technologies. Each week, we dive deep into topics that matter to developers, DevOps engineers, and technology leaders who are building and deploying modern applications.

Our podcast aims to demystify complex container technologies and provide practical insights that you can apply to your own projects. Whether you're a seasoned Kubernetes administrator or just getting started with Docker, you'll find valuable insights and entertainment in each episode.`;

const About = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h2>About the Podcast</h2>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-podcast">
            <h3>The Podcast</h3>
            {podcastDescription.split('\n\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          <div className="host-section">
            <h3>Meet the Hosts</h3>
            
            <div className="host-profile">
              <div className="host-image">
                <img src={jesseImage} alt="Jesse Cafarelli" />
              </div>
              <div className="host-bio">
                <h4>Jesse Cafarelli</h4>
                {jesseBio.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
                <div className="host-social">
                  {jesseTwitter && (
                    <a href={jesseTwitter} target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/733/733579.png" alt="Twitter" />
                    </a>
                  )}
                  {jesseLinkedIn && (
                    <a href={jesseLinkedIn} target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="LinkedIn" />
                    </a>
                  )}
                  {jesseGitHub && (
                    <a href={jesseGitHub} target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="GitHub" />
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className="host-profile">
              <div className="host-image">
                <img src={joshImage} alt="Josh Warhurst" />
              </div>
              <div className="host-bio">
                <h4>Josh Warhurst</h4>
                {joshBio.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
                <div className="host-social">
                  {joshTwitter && (
                    <a href={joshTwitter} target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/733/733579.png" alt="Twitter" />
                    </a>
                  )}
                  {joshLinkedIn && (
                    <a href={joshLinkedIn} target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="LinkedIn" />
                    </a>
                  )}
                  {joshGitHub && (
                    <a href={joshGitHub} target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="GitHub" />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="faq-section">
            <h3>Frequently Asked Questions</h3>
            <div className="faq-item">
              <h4>How can I be a guest on the show?</h4>
              <p>We're always looking for interesting guests who can provide value to our listeners. Please email us at <a href="mailto:hello@containerizedconversations.com">hello@containerizedconversations.com</a> with your name, background, and topics you'd like to discuss.</p>
            </div>
            <div className="faq-item">
              <h4>How can I support the podcast?</h4>
              <p>The best way to support us is by subscribing, leaving a review, and sharing episodes with friends. If you'd like to contribute financially, you can <a href={buyMeCoffeeUrl} target="_blank" rel="noopener noreferrer">buy us a coffee</a>.</p>
              <div className="support-buttons">
                <a href={buyMeCoffeeUrl} target="_blank" rel="noopener noreferrer" className="support-button">
                  <img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" style={{ height: '40px', width: 'auto' }} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;